import { request } from "../../config/helpers/axios-instance";
import { toast } from "react-toastify";
import utils from "../../utils/utils";

// Statuses + document types that are NOT collectible and must not count toward the payable total.
// (Refunded rows are now listed in the table but must not inflate the total; credit notes are reversals.)
const NON_PAYABLE_STATUSES = ['CANCELLED', 'REFUNDED', 'PARTIALLY_REFUNDED'];
const getPaymentItemsList = (paymentItems) => {
    if (!paymentItems) return [];
    const list = Array.isArray(paymentItems) ? paymentItems : Object.values(paymentItems);
    return list.filter(
        (item) => item
            && !NON_PAYABLE_STATUSES.includes(item.status)
            && item.documentType !== 'CREDIT_NOTE'
    );
};

/** Sum of paymentItem.totalAmount (excludes CANCELLED). */
const calculatePaymentItemsTotal = (paymentItems) => {
    return utils.roundOffPaymentAmount(
        getPaymentItemsList(paymentItems).reduce(
            (sum, item) => sum + (parseFloat(item.totalAmount) || 0),
            0
        )
    );
};

/** Payable total for payments UI: sum(paymentItems) when items exist, else order/quotation total. */
const getOrderPayableTotal = ({ paymentItems, orderTotal }) => {
    const itemsTotal = calculatePaymentItemsTotal(paymentItems);
    if (itemsTotal > 0) return itemsTotal;
    return utils.roundOffPaymentAmount(orderTotal);
};

const refreshPayment = async (paymentId, refetchCallback) => {
    if (!paymentId) {
        toast.error('Payment ID is required');
        return;
    }

    try {
        const res = await request({
            url: `payment/admin/refreshPaymentLinkStatusById/${paymentId}`,
            method: "GET",
        })

        if (res.data && res.data.success) {
            toast.success('Payment status refreshed successfully');
            if (refetchCallback) {
                refetchCallback();
            }
        } else {
            toast.error('Failed to refresh payment status');
        }

    } catch (error) {
        toast.error('Failed to refresh payment status');
    }
}

const formatDeactivateError = (error) => {
    if (error == null) return 'Failed to deactivate payment link';
    if (typeof error === 'string') return error;
    try {
        return JSON.stringify(error);
    } catch {
        return 'Failed to deactivate payment link';
    }
};

const deactivatePaymentLink = async (paymentId, refetchCallback) => {
    if (!paymentId) {
        toast.error('Payment ID is required');
        return;
    }

    try {
        const res = await request({
            url: `/payment/admin/deactivate/${paymentId}`,
            method: 'PUT',
        });

        const payload = res?.data;
        if (payload?.success === true) {
            toast.success('PayU payment link deactivated');
            refetchCallback?.();
        } else {
            toast.error(formatDeactivateError(payload?.error));
        }
    } catch (error) {
        const fromBody = error?.response?.data?.error;
        if (fromBody !== undefined) {
            toast.error(formatDeactivateError(fromBody));
        } else {
            toast.error(error?.message || 'Network error; could not deactivate payment link');
        }
    }
};

export {
    refreshPayment,
    deactivatePaymentLink,
    calculatePaymentItemsTotal,
    getOrderPayableTotal,
};
